import React, { useState } from "react";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";
import logoDark from "@/assets/sng-logo-dark.png";

export default function LoginPage({ onSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/login", { username, password });
      setPassword("");
      onSuccess();
    } catch (ex) {
      const d = ex?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Invalid username or password.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-stone-100 flex items-center justify-center p-6" data-testid="login-page">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-stone-200 rounded-2xl p-8 shadow-sm">
        <img src={logoDark} alt="S&G" data-testid="login-logo" className="h-10 w-auto mb-6" />
        <div className="flex items-center gap-2 text-stone-500 text-xs uppercase tracking-[0.18em]">
          <Lock className="w-3.5 h-3.5" /> Private
        </div>
        <div className="font-display text-3xl text-stone-900 mt-2 mb-6">FUB Catalog</div>
        <label className="block text-sm text-stone-600 mb-1" htmlFor="login-username">Username</label>
        <input id="login-username" data-testid="login-username" autoComplete="username" value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="w-full border border-stone-300 rounded-lg px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-amber-400" />
        <label className="block text-sm text-stone-600 mb-1" htmlFor="login-password">Password</label>
        <input id="login-password" data-testid="login-password" type="password" autoComplete="current-password"
          value={password} onChange={(e) => setPassword(e.target.value)}
          className="w-full border border-stone-300 rounded-lg px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-amber-400" />
        {err && <div className="text-sm text-rose-700 mb-4" data-testid="login-error">{err}</div>}
        <button type="submit" disabled={busy || !username || !password} data-testid="login-submit"
          className="w-full bg-stone-900 text-white py-2.5 rounded-lg hover:bg-stone-700 transition-colors disabled:opacity-50">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
